// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  width: 100%;
  height: 100%;
}

body {
  margin: 0;
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background: #f3f5f7;
}

* {
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./web/styles.css"],"names":[],"mappings":"AAAA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["html,\nbody,\n#root {\n  width: 100%;\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  background: #f3f5f7;\n}\n\n* {\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
